import React from "react";
import { useLocation, useMatches, useNavigate } from "react-router-dom";
import "./SectionMenu.css";

export default function SectionMenu() {
  const matches = useMatches();
  const location = useLocation();
  const navigate = useNavigate();

  const sectionMatch = [...matches]
    .reverse()
    .find((match) => match.handle?.section);
  console.log("sectionMatch", sectionMatch);
  if (!sectionMatch) {
    return null;
  }
  const section = sectionMatch.handle.section;
  const sectionPath = sectionMatch.pathname;

  return (
    <div className="section-menu">
      <button type="button" className="section-menu-trigger">
        ☰
      </button>

      <div className="section-menu-panel">
        <div className="section-menu-title">{section.title}</div>

        {section.menuItems.map((item) => {
          const path = `${sectionPath}/${item.path}`;
          // const path = item.path;
          const active = location.pathname === path;

          return (
            <button
              key={item.path}
              type="button"
              className={`section-menu-item ${active ? "active" : ""}`}
              onClick={() => navigate(path)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
